import * as React from 'react';
import { Provider } from '../../models/filespace/provider';
import { CheckMarkIcon } from './Icons';

interface ProviderCardProps {
    provider: Provider;
    isSelected: boolean;
    onSelectProvider: Function;
}

class ProviderCard extends React.Component<ProviderCardProps, any> {
    constructor(props: ProviderCardProps) {
        super(props);

        this.onProviderSelected = this.onProviderSelected.bind(this);
    }

    render() {
        const provider = this.props.provider;
        const comingSoonLabel = <span className="card-label-bottom">Coming soon</span>;

        return (
            <div className={this.getCardClasses()} onClick={this.onProviderSelected}>
                <div className="icon__container">
                    <img className="icon" src={provider.imgSrc} alt={provider.providerData.key} />
                </div>
                <h3>{provider.providerData.primaryName}<br />{provider.providerData.secondaryName}</h3>
                {provider.providerData.certified && provider.providerData.certifiedLabel ? <span className="card-label-right">{provider.providerData.certifiedLabel}</span> : ''}
                {!provider.providerData.certified && comingSoonLabel}
                <a className="btn circle-btn circle-btn-small btn-outline">
                    <CheckMarkIcon width="16px" height="12px" />
                </a>
            </div>
        );
    }

    private onProviderSelected(event: any): void {
        if (!this.props.provider.providerData.certified) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        this.props.onSelectProvider(this.props.provider);
    }

    private getCardClasses(): string {
        return 'flex-card' +
            (this.props.provider.providerData.certified ? '' : ' card-disable') +
            (this.props.isSelected ? ' active' : '');
    }
}

export default ProviderCard;



// WEBPACK FOOTER //
// ./src/webportal/components/common/ProviderCard.tsx